import { Component, OnInit, Inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@environment';
import { DeviceService } from '@app/core/services/util/device.service';
import { DeferImageLoadDirective } from '../../directives/defer-image-load.directive';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-freebie-dialog',
    templateUrl: './freebie-dialog.component.html',
    styleUrls: ['./freebie-dialog.component.scss'],
    standalone: true,
    imports: [NgStyle, DeferImageLoadDirective],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FreebieDialogComponent implements OnInit {

    DEPLOY_URL: string;

    headerText = '';
    bodyText = '';
    footerText = '';
    imagesUrl = [];
    samplings = [];
    popUpDetails: any = {};
    overrideTexts: any;
    lottieUrl: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<FreebieDialogComponent>,
        private deviceService: DeviceService
    ) {
        this.data = data;
        this.lottieUrl = `${environment.assetsUrl}/lottie_files/${environment.brand.id}/confetti`;
        this.DEPLOY_URL = environment.DEPLOY_URL;
        this.samplings = this.data.samplings;
        this.popUpDetails = this.data.popUpDetails;
        this.overrideTexts = this.data.popUpDetails.override_texts;
    }

    ngOnInit() {
        this.initializeData();
    }

    initializeData() {

        this.headerText = this.popUpDetails.popup_header;
        this.bodyText = this.popUpDetails.popup_body;
        this.footerText = this.popUpDetails.popup_footer;

        let totalMarkedPrice = 0;
        let totalSamplingLabel = '';
        
        const resolution = this.deviceService.getResolution('product');
        const imageBaseUrl = `${environment.assetsUrl}/rectangle-19x10/${resolution}/product/`;

        for (let i = 0; i < this.samplings.length; i++) {
            if (i === 0) {
                totalSamplingLabel += this.samplings[i].samplingLabel;
            } else if (i === this.samplings.length - 1) {
                totalSamplingLabel += ' and ' + this.samplings[i].samplingLabel;
            } else {
                totalSamplingLabel += ' , ' + this.samplings[i].samplingLabel;
            }
            totalMarkedPrice += this.samplings[i].marked_price;
            this.imagesUrl.push(imageBaseUrl + this.samplings[i].ids.product_id);
        }
                
        this.bodyText = this.bodyText.replace('{{combination_of_labels}}', totalSamplingLabel);
        
        const thresholdAmount = this.overrideTexts.popup_footer.threshold;
        this.footerText = (totalMarkedPrice < thresholdAmount ? this.overrideTexts.popup_footer.text : this.footerText).replace('{{xxx}}', '' + totalMarkedPrice);
        
    }

    close() {
        this.dialogRef.close();
    }
}
